import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import Hamburger from "./hamburger";
import Logo from "../assets/logo.svg";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

function Navbar() {
  const [showMobile, setShowMobile] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    window.addEventListener("resize", () => {
      if (window.innerWidth >= 700) {
        setShowMobile(false);
      }
    });
    return () => {
      window.removeEventListener("resize", null);
    };
  }, []);

  const clickLink = () => {
    window.scrollTo(0, 0);
    setShowMobile(false);
  };

  return (
    <nav
      className="navbar fixed bg-white p-8 pb-0 !w-screen !max-w-none"
      style={{ top: showMobile ? "0px" : "-190px" }}
    >
      <div>
        <NavLink
          to="/about"
          className="ml-4 mb-2 tracking-wider uppercase"
          onClick={clickLink}
        >
          About
        </NavLink>
        <NavLink
          to="/programs"
          className="ml-4 mb-2 tracking-wider uppercase"
          onClick={clickLink}
        >
          Programs
        </NavLink>
        <NavLink
          to="/scholarships"
          className="ml-4 mb-2 tracking-wider uppercase"
          onClick={clickLink}
        >
          Scholarships
        </NavLink>
        <div
          className="ml-4 mb-2 mt-4 tracking-wider uppercase"
          onClick={clickLink}
        >
          <Link
            to="/apply"
            className="uppercase w-max p-4 text-sm bg-black border border-black text-white hover:text-black hover:bg-white transition-colors duration-500"
            aria-label="link to apply"
          >
            Apply now
          </Link>
        </div>
      </div>
      <div className="flex py-4 bg-white">
        <div className="flex-1">
          <NavLink to="/" onClick={() => window.scrollTo(0, 0)}>
            <img src={Logo} alt="NAIOSW logo" className="h-[60px]" />
          </NavLink>
        </div>
        <div className="md:flex items-center gap-8 hidden">
          <NavLink
            to="/about"
            className="tracking-wider uppercase text-sm"
            onClick={() => window.scrollTo(0, 0)}
          >
            About
          </NavLink>
          <NavLink
            to="/programs"
            className="tracking-wider uppercase text-sm"
            onClick={() => window.scrollTo(0, 0)}
          >
            Programs
          </NavLink>
          <NavLink
            to="/scholarships"
            className="tracking-wider uppercase text-sm"
            onClick={() => window.scrollTo(0, 0)}
          >
            Scholarships
          </NavLink>
          <Link
            to="/apply"
            className={`uppercase w-max py-3 px-6 text-sm transition-colors duration-500 border border-black ${
              pathname === "/apply"
                ? "!bg-white !text-black"
                : "bg-black text-white hover:text-black hover:bg-white"
            }`}
            aria-label="link to apply"
          >
            Apply
          </Link>
        </div>
        <div
          className="block md:hidden mt-4"
          onClick={() => setShowMobile((prev) => !prev)}
        >
          <Hamburger showMobile={showMobile} />
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
